import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieConsentComponent } from './cookie-consent.component';
import { DnPrimaryBtnModule } from '../dn-primary-btn/dn-primary-btn.module';
import { DnMarktingBtnModule } from '../buttons/dn-markting-btn/dn-markting-btn.module';

@NgModule({
  declarations: [CookieConsentComponent],
  imports: [CommonModule, DnPrimaryBtnModule, DnMarktingBtnModule],
  exports: [CookieConsentComponent],
})
export class CookieConsentModule {}
